import styled from 'styled-components';

export const Service = styled.div`
  z-index: 1;

  width: 104px;
  border: 1px solid rgba(77, 148, 129, 1);

  background: rgba(5, 11, 27, 0.95);
`;

export const Container = styled.div`
  position: relative;

  > .title {
    display: flex;
    align-items: center;
    flex-shrink: 0;
    cursor: default;

    position: relative;
    &::before {
      content: '';
      display: block;
      position: absolute;
      bottom: 0;
      left: 5px;
      right: 5px;
      height: 1px;
      border-top: 1px solid rgba(19, 238, 179, 0.1);
    }

    > .title-text {
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: bold;
      color: rgba(19, 238, 179, 1);
      text-shadow: 0px 1px 0px rgba(0, 0, 0, 0.44);
      display: block;
      margin-left: auto;
    }
    > .arrow-up {
      margin-left: 7px;
      margin-right: 20px;

      width: 8px;
      height: 5px;
      display: block;
    }
  }
`;

export const LinkBLockWrapper = styled.div`
  /* padding-top: 18px;
  padding-bottom: 18px; */
  box-sizing: border-box;
  /* height: 252px; */
`;
export const LinkBlock = styled.div`
  overflow-y: scroll;
  height: 100%;

  /*控制整个滚动条*/
  ::-webkit-scrollbar {
    background-color: rgba(77, 148, 129, 1);
    width: 3px;
    /* height: 10px; */
    background-clip: padding-box;
  }

  /*滚动条两端方向按钮*/
  ::-webkit-scrollbar-button {
    background-color: rgba(19, 238, 179, 1);
  }

  /*滚动条中间滑动部分*/
  ::-webkit-scrollbar-thumb {
    background-color: rgba(19, 238, 179, 1);
    border-radius: 5px;
  }

  /*滚动条右下角区域*/
  ::-webkit-scrollbar-corner {
    background-color: rgba(19, 238, 179, 1);
  }
`;

export const Link = styled.div`
  height: 36px;
  line-height: 36px;
  display: block;

  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  cursor: pointer;

  text-align: center;

  &:hover {
    /* color: rgba(255, 255, 255, 1); */
    text-decoration: underline;
    color: rgba(27, 252, 191, 1);
  }
`;
